/**
 * @file LegacySiteRedirect.tsx
 * @description Перенаправления старых адресов в конструктор сайта
 * (phase19.16 Р1-6а; uiux-builder-shell.md §4 — минимум один выпуск):
 * «Сайт → Оформление / Шапка и подвал / Меню / Настройки сайта / SEO /
 * Лента блога / История», «Страницы сайта» и редактор страницы. Параметры
 * старого адреса (`?section=`, `?version=`) переносятся.
 */

import { Navigate, useParams, useSearchParams } from "react-router";

import { builderLink, legacySelection, type BuilderSelection } from "../../lib/site-builder/selection";

interface Props {
  /** Старый экран вида сайта (`appearance`, `header-footer`…); нет — страницы. */
  route?: string;
}

export function LegacySiteRedirect({ route }: Props) {
  const { slug = "", id } = useParams<{ slug: string; id: string }>();
  const [params] = useSearchParams();
  const patch: Partial<BuilderSelection> = route ? legacySelection(route, params) : id ? { pageId: id } : { panel: "pages" };
  return <Navigate to={builderLink(slug, patch)} replace />;
}
